<template>
  <v-form-create name="task" top_title="task_detail">
    <v-form ref="form" v-model="valid">
      <v-layout row px-3>
        <v-flex>
          <v-text-field
            v-model="current_task.title"
            :label="$t('title')"
            ref="title"
            :rules="[fieldRules.required]"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row px-3>
        <v-flex>
          <v-radio-group v-model="current_task.unit_name" row :label="$t('unit_name')">
            <v-radio label="m" value="m"></v-radio>
            <v-radio label="l" value="l"></v-radio>
            <v-radio label="kg" value="kg"></v-radio>
            <v-radio label="pkg" value="pkg"></v-radio>
            <v-radio label="box" value="box"></v-radio>
            <v-radio label="t" value="t"></v-radio>
            <v-radio label="qty" value="qty"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>

      <v-layout row px-2 mx-2 v-for="(limit, index) in current_task.limits" :key="index">
        <v-flex px-2 md6>
          <v-text-field
            v-model="limit.from"
            :label="$t('from')"
            type="number"
            :ref="'from_'+index"
            :rules="[fieldRules.required]"
          ></v-text-field>
        </v-flex>
        <v-flex px-2 md6>
          <v-text-field
            v-model.number="limit.to"
            :label="$t('to')"
            type="number"
            :ref="'to_'+index"
            :rules="[fieldRules.required]"
          ></v-text-field>
        </v-flex>
        <v-flex px-2 md12>
          <v-text-field
            v-model="limit.bonus"
            :label="$t('bonus')"
            type="number"
            :ref="'bonus_'+index"
            :rules="[fieldRules.required]"
          ></v-text-field>
        </v-flex>
        <v-flex px-2 md4>
          <v-radio-group
            v-model="limit.type"
            row
            :label="$t('type')"
            :ref="'type_'+index"
            :rules="[fieldRules.require]"
          >
            <v-radio :label="$t('a')" value="a" />
            <v-radio :label="$t('p')" value="p" />
          </v-radio-group>
        </v-flex>
        <v-flex px-2 md6>
          <v-checkbox v-model="limit.each" :label="$t('calculate_bonus_for_each')" />
        </v-flex>
        <v-flex px-2 mt-3 md2>
          <v-btn icon mt-4 @click="removeLimit(index)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row px-2 mx-2>
        <v-btn
          color="primary"
          text
          @click="current_task.limits.push({ type: 'a'})"
        >{{$t('add_limit')}}</v-btn>
      </v-layout>
    </v-form>
    <template v-if="task_id != undefined" #delete_action>
      <v-btn icon @click="deleteTask">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
    <template #action>
      <v-btn text @click="cancelClicked">{{$t('cancel')}}</v-btn>
      <v-btn text color="primary" :loading="loading_task" :disabled="!valid" @click="save">{{$t('save')}}</v-btn>
    </template>

    <v-dialog v-model="error_dialog" width="600">
      <v-card>
        <v-card-title>Error</v-card-title>
        <v-card-text>{{error_message}}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="error_dialog=false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form-create>
</template>
<script>
import Task from "../../mixins/employees/task";
export default {
  data: () => ({
    error_dialog: false,
    error_message: "",
    name: null,
    valid: false,
    current_task: {
      title: null,
      type: "meal",
      unit_name: "kg",
      limits: [
        {
          from: "0",
          to: 10,
          bonus: "0",
          type: "a",
        },
      ],
    },
    loading_task: false
  }),
  mixins: [Task],
  computed: {
    task_id() {
      return this.$route.query["id"];
    },
  },
  methods: {
    cancelClicked() {
      this.$router.push("/employees/task").catch(() => {});
    },
    async update() {
      this.getTaskById(this.task_id);
    },
    async save() {
      this.loading_task = true
      if (this.$route.params["target"] == "update") {
        await this.updateTask();
      } else {
        await this.createTask();
      }
      this.loading_task = false;
    },
    async deleteTask() {
      const res = await this.$communicator("delete_a_task", {
        arguments: [this.task_id, "delete"],
      });
      if (res && res.data && res.data.data && res.data.data.success) {
        this.cancelClicked();
      } else if (res && res.data && res.data.statusCode == 400) {
        this.error_dialog = true;
        this.error_message = res.data.message;
      } else {
        this.error_dialog = true;
        this.error_message = "Could not delete";
      }
    },
  },
  mounted() {
    if (this.$route.params["target"] == "update") {
      this.update();
    }
  },
};
</script>
